
import { useNavigate } from "react-router-dom";
import React, { useState , useEffect } from "react";
import RecordingHeader from "./RecordingHeader";
import RecordingSidebar from "./RecordingSidebar";
import RecordingHistory from "./Recordinghistory";


const RecordingDashboard = () => {
    const [isSidebarOpen, setIsSidebarOpen] = useState(true);
    const [view, setView] = useState("Recordinghistory"); // Default view
    const [user, setUser] = useState(null);
    const navigate = useNavigate();
  
    
    useEffect(() => {
      const storedUser = JSON.parse(localStorage.getItem("user"));
      const isLoggedIn = localStorage.getItem("isLoggedIn") === "true";
      if (!isLoggedIn || !storedUser) {
        navigate("/");
        return;
      }
      setUser(storedUser);

      
    }, []);

console.log("useruseruseruser",user);


    const handleLogout = () => {
      localStorage.removeItem("qa");
      localStorage.removeItem("isLoggedIn");
      localStorage.removeItem("role");
      localStorage.removeItem("username"); // Clear username on logout
      navigate("/"); // Use navigate instead of window.location.href
    };
  
    // if (!user) {
    //   return <div>Loading...</div>; // Show loading state while user data is fetched
    // }
  
    return (
      <div className="flex h-screen ">

       
        {/* Sidebar */}
        <RecordingSidebar
          isSidebarOpen={isSidebarOpen}
          setIsSidebarOpen={setIsSidebarOpen}
          setView={setView}
          handleLogout={handleLogout}
          user={user}
        />
  
        {/* Main Content */}
        <div className="flex-1 overflow-y-auto h-screen">
          <RecordingHeader user={user?.name}  />
  
          {/* Render views based on the selected option */}
          <main className="flex-grow p-2 bg-gray-100">
            {view === "Recordinghistory" && <RecordingHistory  />}
          
          </main>
        </div>
      </div>
    );
  };
  
  export default RecordingDashboard;